import { getPath } from '@/router/common'

const baseUrl = {
  title: '快找结果',
  path: 'QuickFindResult'
}
export default [
  {
    path: getPath('OtherExpensesInfo', baseUrl),
    name: 'QuickFindResult_OtherExpensesInfo',
    component: () => import(/* webpackChunkName: "QuickFindResult_OtherExpensesInfo" */ '@/views/quickFindResult/otherExpensesInfo/index.vue'),
    meta: {
      title: '其他费用'
    }
  },
  {
    path: getPath('Index', baseUrl),
    name: 'QuickFindResult_Index',
    component: () => import(/* webpackChunkName: "QuickFindResult_Index" */ '@/views/quickFindResult/index/index.vue'),
    meta: {
      title: '快找结果'
    }
  },
  {
    path: getPath('searchList', baseUrl),
    name: 'QuickFindResult_searchList',
    component: () => import(/* webpackChunkName: "QuickFindResult_searchList" */ '@/views/quickFindResult/searchList/index.vue'),
    meta: {
      title: '查询结果'
    }
  },
  {
    path: getPath('TrajectoryInfo', baseUrl),
    name: 'QuickFindResult_TrajectoryInfo',
    component: () => import(/* webpackChunkName: "QuickFindResult_TrajectoryInfo" */ '@/views/quickFindResult/trajectoryInfo/index.vue'),
    meta: {
      title: '新增修改轨迹信息'
    }
  },
  {
    path: getPath('WaybillTracking', baseUrl),
    name: 'QuickFindResult_WaybillTracking',
    component: () => import(/* webpackChunkName: "QuickFindResult_WaybillTracking" */ '@/views/quickFindResult/waybillTracking/index.vue'),
    meta: {
      title: '新增运单跟踪记录'
    }
  },
  {
    path: getPath('SuperSearchList', baseUrl),
    name: 'QuickFindResult_SuperSearchList',
    component: () => import(/* webpackChunkName: "QuickFindResult_SuperSearchList" */ '@/views/quickFindResult/superSearchList/index.vue'),
    meta: {
      title: '超级查询列表'
    }
  },
]
